import {
  Button,
  HStack,
  Image,
  Progress,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useFormContext } from "react-hook-form";
import ReactS3Uploader, { S3Response } from "react-s3-uploader";
import actions from "../../../../actions";
import { useProgress, useLoading } from "../../../hooks/form";
import { useRef, useState } from "react";
import { EventDetailScheduledUpdatesSection } from "@common/interfaces/KYDEvent";

const PosterStep = ({
  data,
  isLoading = false,
}: {
  data: Pick<EventDetailScheduledUpdatesSection["data"], "poster">;
  isLoading?: boolean;
}) => {
  const {
    register,
    watch,
    setValue,
    formState: { defaultValues },
  } = useFormContext();
  const uploadRef = useRef<HTMLInputElement>(null);
  const [progress, updateProgress] = useProgress({ poster: 0 });
  const [loading, updateLoading] = useLoading({ poster: false });

  const poster = watch("poster") || data.poster;
  const previewUrl = watch("preview_url");

  const isShowingOriginal = !poster && data.poster;

  return (
    <VStack py={4}>
      <ReactS3Uploader
        style={{ display: "none" }}
        //@ts-ignore
        inputRef={uploadRef}
        getSignedUrl={(file, callback) =>
          actions.ADMIN.createPublicUploadUrl(file, callback)
        }
        accept="image/*"
        onProgress={(p) => {
          updateProgress("poster", p);
        }}
        onError={(e) => {}}
        preprocess={(f, next) => {
          updateLoading("poster", true);
          next(f);
        }}
        onFinish={(result: S3Response & { cdn_url: string }) => {
          setValue("poster", result.fileKey);
          setValue("preview_url", result.cdn_url);
          updateLoading("poster", false);
          //@ts-ignore

          if (uploadRef.current) {
            uploadRef.current.value = "";
          }
        }}
        uploadRequestHeaders={(file) => ({
          "Content-Type": file.type,
          "x-amz-acl": "private",
        })}
        contentDisposition="auto"
      />
      <VStack w="full" align={"center"} gap={2}>
        <HStack w="full" justifyContent={"space-between"}>
          <Text w="full" fontWeight={"medium"}>
            Event Poster
          </Text>
          <Button
            hidden={poster === defaultValues.poster || !poster}
            variant={"link"}
            fontSize={"xs"}
            color={"gray.500"}
            flexShrink={0}
            cursor={"pointer"}
            onClick={() => {
              setValue("preview_url", null);
              setValue("poster", defaultValues.poster);
            }}
          >
            Revert to saved
          </Button>
        </HStack>
        {isShowingOriginal && (
          <Text w="full" fontSize="xs" color="gray.500">
            This is the original event poster.
          </Text>
        )}
        <Image
          src={previewUrl ? previewUrl : poster}
          width="200px"
          objectFit={"cover"}
          onClick={() => {
            if (uploadRef && uploadRef.current) {
              uploadRef.current.click();
            }
          }}
          cursor={"pointer"}
          aspectRatio={1}
          borderRadius={"md"}
          borderWidth={1}
          backgroundColor={"gray.50"}
          shadow={"md"}
        />
        <Button
          isLoading={loading.poster}
          onClick={() => {
            if (uploadRef && uploadRef.current) {
              uploadRef.current.click();
            }
          }}
        >
          Change Poster
        </Button>
        {progress.poster > 0 && (
          <Progress
            h="15px"
            rounded={"lg"}
            colorScheme={"green"}
            value={progress.poster}
          />
        )}
      </VStack>
    </VStack>
  );
};

export default PosterStep;
